import React, { useEffect, useRef, useState } from 'react';
import { Canvas } from '@react-three/fiber';
import styled from 'styled-components';
import * as THREE from 'three';
import Marker from './Marker';
import EarthGeometry from './EarthGeometry';
import {
  Environment,
  OrbitControls,
  PerspectiveCamera,
} from '@react-three/drei';
import {
  useLoader,
  useThree
} from '@react-three/fiber/dist/react-three-fiber.cjs';
// import { Leva, useControls } from 'leva';
import markers from '../countryData.json'

// const markers = [
//   {
//     localizedTitle: {
//       en: 'Greece',
//       el: 'Ελλάδα'
//     },
//     lat: 39.0742,
//     lon: 21.8243,
//     size: 0.15
//   },
//   {
//     localizedTitle: {
//       en: 'Italy',
//       el: 'Ιταλία'
//     },
//     lat: 41.7719,
//     lon: 14.5674,
//     size: 0.21
//   },
//   {
//     localizedTitle: {
//       en: 'France',
//       el: 'Γαλλία'
//     },
//     lat: 46.6034,
//     lon: 1.8883,
//     size: 0.10
//   },
//   {
//     localizedTitle: {
//       en: 'Germany',
//       el: 'Γερμανία'
//     },
//     lat: 51.1657,
//     lon: 10.4515,
//     size: 0.10
//   },
//   {
//     localizedTitle: {
//       en: 'Spain',
//       el: 'Ισπανία'
//     },
//     lat: 40.4637,
//     lon: -3.7492,
//     size:0.10
//   },
//   {
//     localizedTitle: {
//       en: 'Portugal',
//       el: 'Πορτογαλία'
//     },
//     lat: 39.3999,
//     lon: -8.2245,
//     size: 0.10
//   },
//   {
//     localizedTitle: {
//       en: 'United Kingdom',
//       el: 'Ηνωμένο Βασίλειο'
//     },
//     lat: 55.3781,
//     lon: -3.4360,
//     size: 0.10
//   },
//   {
//     localizedTitle: {
//       en: 'Sweden',
//       el: 'Σουηδία'
//     },
//     lat: 60.1282,
//     lon: 18.6435,
//     size: 0.10
//   },
//   {
//     localizedTitle: {
//       en: 'Norway',
//       el: 'Νορβηγία'
//     },
//     lat: 60.4720,
//     lon: 8.4689,
//     size: 0.10
//   },
//   {
//     localizedTitle: {
//       en: 'Denmark',
//       el: 'Δανία'
//     },
//     lat: 56.2639,
//     lon: 9.5018,
//     size: 0.10
//   },
//   {
//     localizedTitle: {
//       en: 'Poland',
//       el: 'Πολωνία'
//     },
//     lat: 51.9194,
//     lon: 19.1451,
//     size: 0.10
//   },
//   {
//     localizedTitle: {
//       en: 'Switzerland',
//       el: 'Ελβετία'
//     },
//     lat: 46.8182,
//     lon: 8.2275,
//     size: 0.10
//   },
//   {
//     localizedTitle: {
//       en: 'Austria',
//       el: 'Αυστρία'
//     },
//     lat: 47.5162,
//     lon: 14.5501,
//     size: 0.10
//   },
//   {
//     localizedTitle: {
//       en: 'Belgium',
//       el: 'Βέλγιο'
//     },
//     lat: 50.8503,
//     lon: 4.3517,
//     size: 0.10
//   },
//   {
//     localizedTitle: {
//       en: 'Netherlands',
//       el: 'Ολλανδία'
//     },
//     lat: 52.1326,
//     lon: 5.2913,
//     size: 0.10
//   },
//   {
//     localizedTitle: {
//       en: 'Ireland',
//       el: 'Ιρλανδία'
//     },
//     lat: 53.4129,
//     lon: -8.2439,
//     size: 0.10
//   },
//   {
//     localizedTitle: {
//       en: 'Finland',
//       el: 'Φινλανδία'
//     },
//     lat: 61.9241,
//     lon: 25.7482,
//     size: 0.10
//   },
//   {
//     localizedTitle: {
//       en: 'Czech Republic',
//       el: 'Τσεχία'
//     },
//     lat: 49.8175,
//     lon: 15.4730,
//     size: 0.10
//   },
//   {
//     localizedTitle: {
//       en: 'Hungary',
//       el: 'Ουγγαρία'
//     },
//     lat: 47.1625,
//     lon: 19.5033,
//     size: 0.10
//   },
//   {
//     localizedTitle: {
//       en: 'Romania',
//       el: 'Ρουμανία'
//     },
//     lat: 45.9432,
//     lon: 24.9668,
//     size: 0.10
//   },
//   {
//     localizedTitle: {
//       en: 'United States',
//       el: 'Ηνωμένες Πολιτείες'
//     },
//     lat: 37.0902,
//     lon: -95.7129,
//     size: 0.4
//   },
//   {
//     localizedTitle: {
//       en: 'Canada',
//       el: 'Καναδάς'
//     },
//     lat: 56.1304,
//     lon: -106.3468,
//     size: 0.16
//   },
//   {
//     localizedTitle: {
//       en: 'Brazil',
//       el: 'Βραζιλία'
//     },
//     lat: -14.2350,
//     lon: -51.9253,
//     size: 0.18
//   },
//   {
//     localizedTitle: {
//       en: 'Australia',
//       el: 'Αυστραλία'
//     },
//     lat: -25.2744,
//     lon: 133.7751,
//     size: 0.12
//   },
//   {
//     localizedTitle: {
//       en: 'India',
//       el: 'Ινδία'
//     },
//     lat: 20.5937,
//     lon: 78.9629,
//     size: 0.2
//   },
//   {
//     localizedTitle: {
//       en: 'China',
//       el: 'Κίνα'
//     },
//     lat: 35.8617,
//     lon: 104.1954,
//     size: 0.2
//   },
//   {
//     localizedTitle: {
//       en: 'South Africa',
//       el: 'Νότια Αφρική'
//     },
//     lat: -30.5595,
//     lon: 22.9375,
//     size: 0.14
//   },
//   {
//     localizedTitle: {
//       en: 'Japan',
//       el: 'Ιαπωνία'
//     },
//     lat: 36.2048,
//     lon: 138.2529,
//     size: 0.16
//   },
//   {
//     localizedTitle: {
//       en: 'South Korea',
//       el: 'Νότια Κορέα'
//     },
//     lat: 35.9078,
//     lon: 127.7669,
//     size: 0.15
//   },
//   {
//     localizedTitle: {
//       en: 'Mexico',
//       el: 'Μεξικό'
//     },
//     lat: 23.6345,
//     lon: -102.5528,
//     size: 0.18
//   },
//   {
//     localizedTitle: {
//       en: 'Argentina',
//       el: 'Αργεντινή'
//     },
//     lat: -38.4161,
//     lon: -63.6167,
//     size: 0.14
//   },
//   {
//     localizedTitle: {
//       en: 'Saudi Arabia',
//       el: 'Σαουδική Αραβία'
//     },
//     lat: 23.8859,
//     lon: 45.0792,
//     size: 0.15
//   },
//   {
//     localizedTitle: {
//       en: 'Russia',
//       el: 'Ρωσία'
//     },
//     lat: 61.5240,
//     lon: 105.3188,
//     size: 0.4
//   },
//   {
//     localizedTitle: {
//       en: 'Egypt',
//       el: 'Αίγυπτος'
//     },
//     lat: 26.8206,
//     lon: 30.8025,
//     size: 0.12
//   }
// ];

// const ViewerContainer = styled.div`
//   width: 100%;
//   top: -3rem;
//   height: 100%;
//   position: absolute;
//   z-index: -5;
// `;



const CanvasBG = ({handleLabelClick, divRef, showModal, canvasRef}) => {
  // const { rotationX, rotationY, rotationZ } = useControls({
  //   // label:"group rotation",
  //   rotationX: { value: 0, min: -Math.PI, max: Math.PI, step: 0.01 },
  //   rotationY: { value: -2, min: -Math.PI, max: Math.PI, step: 0.01 },
  //   rotationZ: { value: 0, min: -Math.PI, max: Math.PI, step: 0.01 },
  // });
  // const { positionGX, positionGY, positionGZ } = useControls({
  //   // label:"group positionG",
  //   positionGX: { value: -8, min: -500, max: 500, step: 0.01 },
  //   positionGY: { value: -1, min: -500, max: 500, step: 0.01 },
  //   positionGZ: { value: 45, min: -500, max: 500, step: 0.01 },
  // });
  // const { positionX, positionY, positionZ } = useControls({
  //   // label:"Camera position",
  //   positionX: { value: -2.5, min: -500, max: 500, step: 0.01 },
  //   positionY: { value: 0, min: -500, max: 500, step: 0.01 },
  //   positionZ: { value: 125, min: -500, max: 500, step: 0.01 },
  // });
  
  const cameraOpts = {
    fov: 45,
    near: 0.0001,
    far: 100000,
    position: [0, 0, 80]
  };
  const [isOrbiting, setIsOrbiting] = useState(false);
  const onCanvasCreated = ({ gl }) => {
    /* eslint no-param-reassign: "error" */
    gl.shadowMap.enabled = true;
    gl.shadowMap.type = THREE.PCFShadowMap;
    // gl.gammaOutput = true;
    // gl.gammaFactor = 2.2;
    gl.toneMappingExposure = 1.0;
    /* eslint-env browser */
    gl.setPixelRatio(window.devicePixelRatio);
  };
  const earthGroupRef = useRef()
  const parentGroup = useRef()


  const backgrounTexture = useLoader(THREE.TextureLoader, '/night-sky.png');
  const [planePosition, setPlanePosition] = useState(new THREE.Vector3());
 

  return (
    <>
    {/* <Leva position="top left"/> */}
    <Canvas
      // camera={{ fov: 75, position: [0, 0, 0]}}
      //   pixelRatio={window.devicePixelRatio}
      // onCreated={onCanvasCreated}
    >
      <PerspectiveCamera
        makeDefault
        // position={[positionX, positionY, positionZ]}
        position={[-2.5, 0, 125]}
        fov={60}
        far={1000}
        zoom={10}
      />
      {/* <ambientLight intensity={2} /> */}
      {/* <pointLight position={[10, 10, 10]} /> */}
      {/* <group rotation={[rotationX, rotationY, rotationZ]} position={[-30,0,0]} ref={parentGroup}> */}
        {/* <group ref={earthGroupRef} position={[positionGX, positionGY, positionGZ]} rotation={[0,-2,0]}> */}
        <group ref={earthGroupRef} position={[-8, -1, 45]} rotation={[0,-2,0]}>
          <EarthGeometry isOrbiting={isOrbiting} showModal={showModal} planePosition={planePosition} divRef={divRef} earthGroupRef={earthGroupRef} setPlanePosition={setPlanePosition} canvasRef={canvasRef}/>
        {markers.map((m) => (
          <Marker key={m.title} {...m} handleLabelClick={handleLabelClick} />
        ))}
        </group>
      {/* </group> */}

      {/* <Environment map={backgrounTexture} background backgroundBlurriness={0.5}/> */}
      {/* <OrbitControls
        enablePan={false}
        enableZoom={false}
        // enableZoom={true}
        minPolarAngle={Math.PI / 2}
        maxPolarAngle={Math.PI / 2}
        autoRotate={false}
        onStart={() => setIsOrbiting(true)}
        onEnd={() => setIsOrbiting(false)}
      /> */}
       {/* <axesHelper args={[2]} /> */}
    </Canvas>
    
    </>
  );
};

export default CanvasBG;
